type Now = {
    (): number,
    last: number | undefined,
};

const now = function () {
    const time = Date.now();
    const last = now.last || time;
    return now.last = time > last ? time : last + 1;
} as Now;

export function uniqId(prefix = 'id') {
    return `${prefix}${now()}`;
}
